import React, { useEffect, useRef, useState } from "react";
import PageTab from "@/components/i-pageTab/i-pageTab";
import PageTable from "@/components/i-pageTable/i-pageTable";
import styles from "@/static/css/index.module.css";
import {
  getOperationVipIncomePageList,
  operationVipIncomeExport,
} from "@/api/operation";

import { downloadFile, getTimeFormat, setIcons } from "@/utils/common";
import { useSelector, useDispatch, useStore } from "react-redux";
import { dictInfoAsync } from "@/stores/dictInfo";
import dayjs from "dayjs";
import { Tag } from "antd";

const Vip_detail = () => {
  const dispatch = useDispatch();
  const {
    state: { account_trend_type },
  } = useSelector((state: { dictInfo: any }) => state.dictInfo);

  const [pageData, setPageData] = useState<
    GetOperationVipIncomePageListRes["rows"]
  >([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [formData, setFormData] = useState<GetOperationVipIncomePageListParams>(
    {
      ypageNum: 1,
      ypageSize: 10,
    }
  );

  const formTab = [
    {
      label: "商城订单号",
      name: "orderId",
      type: "input",
    },
    {
      label: "充值订单号",
      name: "rechangeAmountId",
      type: "input",
    },
    {
      label: "用户名称",
      name: "nickName",
      type: "input",
    },
    {
      label: "用户手机号",
      name: "mobile",
      type: "input",
    },
    {
      label: "运营商ID",
      name: "operatorId",
      type: "input",
    },
    {
      label: "资金走向类型",
      name: "accountTrend",
      type: "select",
      options: account_trend_type,
    },
    {
      label: "时间范围",
      name: "rangePicker",
      type: "rangePicker",
      width: "380px",
    },
  ];

  const footer = [
    {
      title: "导出",
      icon: setIcons("DownloadOutlined"),
      onClick: () => exportExcel(),
      loading: exportLoading,
    },
  ];

  const columns = [
    {
      title: "用户名称",
      dataIndex: "nickName",
      key: "nickName",
    },
    {
      title: "用户手机号",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "运营商名称",
      dataIndex: "operatorName",
      key: "operatorName",
    },
    {
      title: "商城订单号",
      dataIndex: "orderId",
      key: "orderId",
    },
    {
      title: "充值订单号",
      dataIndex: "rechangeAmountId",
      key: "rechangeAmountId",
    },
    {
      title: "资金走向类型",
      dataIndex: "accountTrendLabel",
      key: "accountTrendLabel",
      render: (val: string) => <Tag color="blue">{val}</Tag>,
    },
    {
      title: "收益金额",
      dataIndex: "incomeAmount",
      key: "incomeAmount",
    },
    {
      title: "创建时间",
      dataIndex: "createTime",
      key: "createTime",
    },
  ];

  useEffect(() => {
    getPageData();
  }, [formData]);
  useEffect(() => {
    !account_trend_type && dispatch(dictInfoAsync("account_trend_type") as any);
  }, []);

  const getPageData = async () => {
    setLoading(true);
    try {
      const data = await getOperationVipIncomePageList(formData);
      const page = data.rows?.map((i, v) => {
        return {
          ...i,
          key: v,
        };
      });
      setPageData(page);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const exportExcel = async () => {
    setExportLoading(true);
    try {
      const data = await operationVipIncomeExport(formData);
      downloadFile(
        data as any,
        "运营商VIP收入明细" + getTimeFormat(new Date(), "yyyy-MM-dd")
      );
    } catch (error) {
    } finally {
      setExportLoading(false);
    }
  };

  const search = (val: any) => {
    setFormData({
      ...formData,
      ...val,
      ypageNum: 1,
    });
  };

  const reset = () => {
    setFormData({
      ypageNum: 1,
      ypageSize: 10,
    });
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };
  return (
    <div>
      <PageTab
        search={search}
        reset={reset}
        formTab={formTab}
        footer={footer}
        defaultTimer={[]}
      ></PageTab>
      <PageTable
        loading={loading}
        pageChange={pageChange}
        size="small"
        rowKey="key"
        columns={columns}
        data={pageData}
        pagination={{
          current: formData.ypageNum!,
          pageSize: formData.ypageSize!,
          total: total,
        }}
      ></PageTable>
    </div>
  );
};

export default Vip_detail;
